import { contractServiceClient } from '@lib/documentServiceClient';
import { createReviewService } from '@workpay/ds-shared/services/reviewService';

export const dsReviewService = createReviewService(contractServiceClient);
